import React from "react";
import BatchPrint from "../BatchPrint";
import Content from "./Content";
import "./index.scss"

import { fetchReport } from "../../services/readingrope";

// Batch Print for Parent Report

export default function InstructionalReportBatchPrint(props) {
  return (
    <BatchPrint
      title="Instructional Recommendations Report"
      getStudentData={getStudentData}
      renderReport={renderReport}
    />
  );

  async function getStudentData(student, selections) {
    const { classroom, selectedStatePercentileCuts, locale } =
      selections;
    const readingRopeReport = await fetchReport(classroom.id, student, selectedStatePercentileCuts, locale);
    return { student, readingRopeReport, classroom };
  }

  function renderReport(report) {
    if (!report) return null;
    const {student, readingRopeReport, classroom} = report;
    return (
      <Content key={student.value} student={student} classroom={classroom} readingRopeReport={readingRopeReport} />
    );
  }
}
